import stableUUID from "common/utils/stableUUID";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_415: DocMigration = {
  maxSchemaVersion: "0.0.415",
  description: "Move option disconnect conditions into new optionLocks table",
  apply(json: any) {
    // add new empty table
    if (!json.hasOwnProperty("optionLocks")) {
      json.optionLocks = {};
    }
    if (!json.hasOwnProperty("auxOptionSets")) {
      return json;
    }

    for (const optionSetId in json.auxOptionSets) {
      const { disconnectCondition, disconnectConditionOptions, name } = json.auxOptionSets[optionSetId];
      if (disconnectCondition || disconnectConditionOptions) {
        const optionLock = {
          optionSetId: optionSetId,
          name: json.optionSets[optionSetId]?.name ?? name, // use the latest name from option set
          entityType: "OPTION_LOCK",
          disconnectCondition,
          disconnectConditionOptions,
          sortIndex: 0,
        };
        /**
         * A stable id is required because option locks can be doc ref'd.
         * docMigrations are re-run every time an unmigrated doc is pulled in via docRef, which requires stable id generation
         * for the docRef'd entityIds to be persisted.
         */
        const id = stableUUID(optionLock);
        json.optionLocks[id] = {
          id,
          ...optionLock,
        };

        // remove from auxOptionSets
        delete json.auxOptionSets[optionSetId].disconnectCondition;
        delete json.auxOptionSets[optionSetId].disconnectConditionOptions;
      }
    }

    return json;
  },
};

export default migration_0_0_415;
